import React from 'react'
import PropTypes from 'prop-types'

import getLoginPortalUrl from '../../utils/getLoginPortalUrl'

import styles from './styles'

function CTVRegistrationBanner({ currentDomain }) {
  const profileHost = getLoginPortalUrl(currentDomain)

  return (
    <div
      className="CTVRegistration"
    >
      <div className="inner">
        <p><strong>Trying to activate STV Player on your TV?</strong> <a href={`${profileHost}/activate`} className="link">Click here</a> to enter your code.</p>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

CTVRegistrationBanner.propTypes = {
  currentDomain: PropTypes.string,
}
CTVRegistrationBanner.defaultProps = {
  currentDomain: '',
}

export default CTVRegistrationBanner
